module.exports = __webpack_public_path__ + "static/img/ellipta_blue.bf03b50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/trackers/ellipta_blue.jpg
// module id = eKYf
// module chunks = 0